<script>
    import {
        PatientQuotePatientDetails as PatientDetails,
        PatientQuotePatientContactDetails as PatientContactDetails,
        PatientQuoteProcedureDetails as ProcedureDetails,
        PatientQuoteDoctorDetails as DoctorDetails,
        PatientQuoteNotes as Notes,
    } from "./components/index.svelte";

    export let patientDetails = {},
        patientContacts = [],
        procedureDetails = {},
        doctorDetails = {},
        billingData = [],
        patientEncounter,
        encounterId,
        isNotesInEdit = false,
        eclipseLogsData = [],
        reloadPatientDetails = () => {},
        updatePatientEncounter = () => {};

    export let notesRef;
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
        <PatientDetails
            bind:patientEncounter
            bind:eclipseLogsData
            {patientDetails}
            {billingData}
            {encounterId}
            {reloadPatientDetails}
            {updatePatientEncounter}
        />

        <ProcedureDetails {procedureDetails} {doctorDetails} />

        <!-- <DoctorDetails {doctorDetails} /> -->

        <Notes
            bind:this={notesRef}
            bind:patientDetails
            bind:isInEdit={isNotesInEdit}
            {patientEncounter}
            {reloadPatientDetails}
        />

        <PatientContactDetails
            patientID={patientDetails.id}
            encounterID={patientDetails.patientEncounterId}
            {patientContacts}
            {reloadPatientDetails}
        />
    </div>
</div>
